import { Suspense, type PropsWithChildren } from 'react'

import { PageLayoutSkeleton } from '@/layouts/page'

import { UltimosAtendimentosPageSkeleton } from './skeleton'

export const UltimosAtendimentosPageSuspense = ({ children }: PropsWithChildren) => {
  return (
    <Suspense
      fallback={
        <PageLayoutSkeleton>
          <UltimosAtendimentosPageSkeleton />
        </PageLayoutSkeleton>
      }
    >
      {children}
    </Suspense>
  )
}
